import React, { createContext, useState, useContext, useEffect } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';

export const ChannelContext = createContext();

export const ChannelContextProvider = ({ children }) => {
    const { user, setOpenAlert, setSeverity, setAlertMessage } = useContext(CommonContext);

    const initialFilters = {
        searchBy: 'channel_name',
        searchValue: '',
        dateRange: { startDate: null, endDate: null },
    };
    const [filters, setFilters] = useState(initialFilters);

    const [addModal, setAddModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [allPickupRequest, setAllPickupRequest] = useState([]);
    const [allData, setAllData] = useState([]);
    const [openAlert, setOpenAlertLocal] = useState(false);
    const [alertMessage, setAlertMessageLocal] = useState('');
    const [severity, setSeverityLocal] = useState('success');
    const [activeMerchantId, setActiveMerchantId] = useState(null); // persists merchant context across filter calls

    // AddChannel.js expects these names specifically
    const setAlertMesaage = (msg) => {
        setAlertMessageLocal(msg);
        setAlertMessage(msg);
    };

    const setOpenAlertMapped = (val) => {
        setOpenAlertLocal(val);
        setOpenAlert(val);
    };

    const setSeverityMapped = (val) => {
        setSeverityLocal(val);
        setSeverity(val);
    };

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
        setViewData(null);
        setIsEdit(false);
    };

    const onLoadApi = (merchantIdOrFilters = null, customFilters = filters) => {
        setIsLoading(true);
        setFirstLoading(false);

        // Support both onLoadApi(merchantId) and onLoadApi(filters)
        let merchantId = null;
        let activeFilters = customFilters;

        if (merchantIdOrFilters && typeof merchantIdOrFilters === 'object') {
            // Called with filters object (e.g. from FilterBar)
            activeFilters = merchantIdOrFilters;
            merchantId = activeMerchantId; // reuse the stored merchant context
        } else if (merchantIdOrFilters) {
            // Called with a merchantId (e.g. from ChannelScreenView on mount)
            merchantId = merchantIdOrFilters;
            setActiveMerchantId(merchantIdOrFilters); // persist for future filter calls
        } else {
            // Called with no args (e.g. after status toggle)
            merchantId = activeMerchantId;
        }

        let payload = {};

        if (user?.user_type === 'Merchant') {
            payload.merchant_id = user?.id;
        } else if (merchantId) {
            payload.merchant_id = merchantId;
        }

        if (activeFilters?.searchBy && activeFilters?.searchValue) {
            payload[activeFilters.searchBy] = activeFilters.searchValue;
        }

        if (activeFilters?.dateRange?.startDate) {
            payload.start_date = activeFilters.dateRange.startDate;
        }
        if (activeFilters?.dateRange?.endDate) {
            payload.end_date = activeFilters.dateRange.endDate;
        }

        commonApi.post('channel-integration/list-channel', payload)
            .then((response) => {
                setIsLoading(false);
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllPickupRequest(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setFirstLoading(true);
                console.error('Error fetching channels:', error);
            });
    };

    const contextValue = {
        addModal,
        setAddModal,
        handleAddModal,
        handleCloseModal,
        isLoading,
        setIsLoading,
        firstLoading,
        isEdit,
        setIsEdit,
        viewData,
        setViewData,
        allPickupRequest,
        setAllPickupRequest,
        allData,
        setAllData,
        filters,
        setFilters,
        initialFilters,
        onLoadApi,
        activeMerchantId,
        openAlert: openAlert,
        setOpenAlert: setOpenAlertMapped,
        alertMessage: alertMessage,
        setAlertMesaage,
        severity: severity,
        setSeverity: setSeverityMapped,
    };

    return (
        <ChannelContext.Provider value={contextValue}>
            {children}
        </ChannelContext.Provider>
    );
};
